import { RDEqipEligibilityConservationCRP } from '@cibo/core'
import { conservationProgram } from '../ConservationPrograms'

export const ConservationCRP = conservationProgram<RDEqipEligibilityConservationCRP>(
  'crpEnrolled',
  'CRP',
  'eqipEligibilityConservationCRP',
  '@cibo/landmanager/ConservationCRP'
)
